<mat-form-field subscriptSizing="dynamic">
    @if (label()) {
        <mat-label>{{ label() }}</mat-label>
    }
    <input
        #control
        matInput
        currencyMask
        [required]="required()"
        [ngModel]="value()"
        [options]="currencyMaskConfig"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [type]="type()"
        (blur)="onValueChanged()"
        (ngModelChange)="onNgModelChanged($event)"
        (keyup)="keyPressed($event)" />
    @if (hint()) {
        <mat-hint>{{ hint() }}</mat-hint>
    }
    @if (hasSuffix()) {
        <ng-container matSuffix>
            <ng-content select="[suffix]" />
        </ng-container>
    }
    @if (hasPrefix()) {
        <ng-container matPrefix>
            <ng-content select="[prefix]" />
        </ng-container>
    }
    @if (hasError()) {
        <ng-container matError>
            <ng-content select="[error]" />
        </ng-container>
    }
</mat-form-field>
